import type { DeepPartial } from '@luna/utils-ts';
import { BUNDLE_ORDER_TYPE } from '@shared/payments-types';

import type { PaymentOrders } from './PaymentOrders';

export const RO: DeepPartial<PaymentOrders> = {
    showChannelId: true,
    alwaysRedo: false,
    orderBundler: {
        config: {
            DEFAULT: [
                {
                    combination: [
                        BUNDLE_ORDER_TYPE.DOMESTIC,
                        BUNDLE_ORDER_TYPE.SEPA,
                        BUNDLE_ORDER_TYPE.INTERNATIONAL,
                        BUNDLE_ORDER_TYPE.OWN_FX,
                    ],
                    maxSize: 50,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: true,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
            ],
        },
    },
    failedOrderStates: [
        'ABG',
        'STO',
        'RED',
        'XPR',
        'NGA',
        'AGB',
        'BAM',
        'BAN',
        'BPA',
        'BPR',
        'CBA',
        'EEI',
        'FRD',
        'IPA',
        'IPC',
        'IPE',
        'ISA',
        'KAG',
        'OBG',
        'RBC',
        'REC',
    ],
};
